module.exports = __webpack_public_path__ + "img/baseline-close-24px.49c78649.svg";